/**
 * Whether a company's "hide a zero balance" setting hides this balance. Shared by the dashboard tile and the membership
 * page so the two can't drift apart. Points are floored the way they're shown, so 0.4 points counts as zero.
 *
 * Only the balance hides. An offer's "earn N more to redeem" line still shows, since it tells the member what to do
 * next. The setting serves coupon-only programs and brand-new members. Product decision, CIN-7192.
 *
 * @param {boolean} hideZeroBalance - the group's hide_zero_balance setting
 * @param {number} [points] - the member's current points
 */
export const hidesZeroBalance = (hideZeroBalance, points) => Boolean(hideZeroBalance) && Math.floor(points || 0) === 0;
